import React, { PropsWithChildren } from 'react';

const SidebarContext = React.createContext(false);

const SidebarProvider = ({ children }: PropsWithChildren): JSX.Element => (
    <SidebarContext.Provider value>
        {children}
    </SidebarContext.Provider>
);

export const useIsWithinSidebar = (): boolean => React.useContext(SidebarContext);

export default SidebarProvider;
